export const capitalizeWords = (str) => {
  const arr = str?.split(/[\s-]+/)
  return arr?.map(word => {
    const firstLetter = word.charAt(0)?.toUpperCase();
    const rest = word?.slice(1)?.toLowerCase();

    return firstLetter + rest;
  })?.join(' ');
}